// import React, { Component } from 'react'
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { signUp, signIn } from "../../api/auth";
import messages from "../shared/AutoDismissAlert/messages";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import SignIn from "./SignIn";

const SignUp = (props) => {
  // constructor(props) {
  // 	super(props)

  // 	this.state = {
  // 		email: '',
  // 		password: '',
  // 		passwordConfirmation: '',
  // 	}
  // }
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const navigate = useNavigate();

  const onSignUp = (event) => {
    event.preventDefault();

    const { msgAlert, setLoginUser } = props;
    //   const msgAlert = props.msgAlert;
    //   const setUser = props.setUser
    const credentials = { email, password, passwordConfirmation };
    //  credentials.email, credentials.password
    signUp(credentials)
      .then((res) => console.log(res.data.user))
      .then(() =>
        msgAlert({
          heading: "Sign Up Success",
          message: messages.signUpSuccess,
          variant: "success",
        })
      )
      .then(() => navigate("/sign-in"))
      .catch((error) => {
        setEmail("");
        setPassword("");
        setPasswordConfirmation("");
        msgAlert({
          heading: "Sign Up Failed with error: " + error.message,
          message: messages.signUpFailure,
          variant: "danger",
        });
      });
  };

  return (
    <div className="row">
      <div className="col-sm-10 col-md-8 mx-auto mt-5">
        <h3>Sign Up</h3>
        <Form onSubmit={onSignUp}>
          <Form.Group controlId="email">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              required
              type="email"
              name="email"
              value={email}
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              required
              name="password"
              value={password}
              type="password"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="passwordConfirmation">
            <Form.Label>Password Confirmation</Form.Label>
            <Form.Control
              required
              name="passwordConfirmation"
              value={passwordConfirmation}
              type="password"
              placeholder="Confirm Password"
              onChange={(e) => setPasswordConfirmation(e.target.value)}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
        <p>Already have an account? <a href='sign-in'>Login</a></p>
      </div>
    </div>
  );
};

export default SignUp;
